const canvasOcclusalSx = (theme) => ({
    occlusalContainer: {
        maxWidth: 'calc( (100vh - 200px) / 2)',
        margin: '0 auto',
    },
    occlusalCanvas: {
        aspectRatio: '1 / 2',
    },
});

export default canvasOcclusalSx;
